// extracted by mini-css-extract-plugin
module.exports = {"targetTotalWrapper":"ConditionsForm_targetTotalWrapper__LLxv_","totalTag":"ConditionsForm_totalTag__q7wF3","viewTargetListLink":"ConditionsForm_viewTargetListLink__xDE7E"};